import React, { useMemo } from 'react';
import { Chip, useTheme } from '@mui/material';
import { ChipProps } from '@mui/material/Chip';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import { PillButtonFieldProps } from './types';
import { useController } from './useController';
import { getPillChipSx } from './utils';

const PillButtonField: React.FC<PillButtonFieldProps & Record<string, unknown>> = (props) => {
  const { emptyText = '-', variant = 'filled', label: _label } = props;

  const theme = useTheme();
  const ctrl = useController(props);

  if (!ctrl) return <span>{emptyText}</span>;

  const { rawValue, displayValue, chipColor, isCustomColor } = ctrl ?? {};

  const chipProps: ChipProps = useMemo(() => {
    const base: ChipProps = {
      label: displayValue,
      variant,
    };

    // Only set Chip's `color` prop for standard MUI colors.
    // For custom (turn_*) colors, styling is done via sx.
    if (!isCustomColor && chipColor) {
      base.color = chipColor as ChipProps['color'];
    }

    return base;
  }, [displayValue, variant, isCustomColor, chipColor]);

  const sx = useMemo(
    () =>
      getPillChipSx({
        theme,
        variant,
        chipColor,
        isCustomColor,
      }),
    [chipColor, isCustomColor, theme, variant]
  );

  return (
    <CopyToClipboard text={rawValue}>
      <Chip {...chipProps} sx={sx} />
    </CopyToClipboard>
  );
};

export default PillButtonField;
